'use strict';

(function () {

  angular
    .module('specsguardApp')
    .component('sgElementStatus', {
      template: `
      <span>
        <md-icon ng-style="{ 'color': $ctrl.elementStatus.color }">
          label
          <md-tooltip ng-if="!$ctrl.hideTooltip && $ctrl.statusName" md-direction="top">{{ $ctrl.statusName }}</md-tooltip>
        </md-icon>
      </span>
      `,
      bindings: {
        element: '<',
        status: '<',
        hideTooltip: '<'
      },
      controller: 'sgElementStatusCtrl'
    });

})();
